module.exports = __webpack_public_path__ + "img/bulle_1_choix_metier.bf20c16c.png";